import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** «Дагах»: tenders / companies / organizations a person keeps an eye on — kept in this
 *  browser (no server list yet), listed in the side dock's «Дагаж буй». */
export type FollowKind = 'tender' | 'bidder' | 'organization' | 'governor';

export interface FollowItem {
  kind: FollowKind;
  id: number;
  label: string;
  /** when it was followed (ms) */
  at: number;
}

interface FollowState {
  items: FollowItem[];
  toggle: (item: Omit<FollowItem, 'at'>) => void;
  remove: (kind: FollowKind, id: number) => void;
}

export const isFollowing = (items: FollowItem[], kind: FollowKind, id: number) =>
  items.some((i) => i.kind === kind && i.id === id);

export const useFollowStore = create<FollowState>()(
  persist(
    (set) => ({
      items: [],
      toggle: (item) => set((s) => (isFollowing(s.items, item.kind, item.id)
        ? { items: s.items.filter((i) => !(i.kind === item.kind && i.id === item.id)) }
        : { items: [{ ...item, at: Date.now() }, ...s.items] })),
      remove: (kind, id) => set((s) => ({ items: s.items.filter((i) => !(i.kind === kind && i.id === id)) })),
    }),
    { name: 'follow-items' },
  ),
);
